module.exports = __webpack_public_path__ + "img/9788965880226.a4176469.jpg";